import { Deserializable } from '../interfaces';

export class Country implements Deserializable {
  id: number;
  descripcion: string;
  abreviatura: string;

  constructor() {
    this.id = 0;
    this.descripcion = '';
    this.abreviatura = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
